<content>
  <ng-content></ng-content>
</content>